import { Collection, Model } from 'web-mojo';

class Operator extends Model {
    constructor(data = {}) {
        super(data, {
            endpoint: '/api/routes/operator'
        });
    }

    nameOrId() {
        return this.get('display_name') || this.get('id');
    }

    email() {
        const user = this.get('user');
        return user ? user.email : '';
    }

    username() {
        const user = this.get('user');
        return user ? user.username : '';
    }

    isActive() {
        return this.get('status') === 'active';
    }
}

class OperatorList extends Collection {
    constructor(options = {}) {
        super({
            ModelClass: Operator,
            endpoint: '/api/routes/operator',
            ...options
        });
    }
}

const OperatorForms = {
    edit: {
        title: 'Edit Operator',
        fields: [
            { name: 'phone', type: 'text', label: 'Phone', columns: 6 },
            { name: 'status', type: 'select', label: 'Status', columns: 6, options: [
                { value: 'active', label: 'Active' },
                { value: 'inactive', label: 'Inactive' },
            ]},
        ]
    }
};

Operator.EDIT_FORM = OperatorForms.edit;

export { Operator, OperatorList, OperatorForms };
